import { type OptionItem } from "../component";
export type AutoCompleteValue = string | number;

export const getAvailableOptions = (options: OptionItem<any>[], excludeOptionValues?: any[]): OptionItem<any>[] => {
  if (!options.length) return [];

  if (excludeOptionValues) options = options.filter((x) => !excludeOptionValues!.includes(x.value));
  return options;
};

export const getOptionLabel = (options: OptionItem<string>[], val: string): string => {
  const option = options.find((opt) => opt.value == val);
  return (option ? option.label || (option.descriptions ?? [])[0]?.label : undefined) || "";
};
